<template lang="pug">
  #MySa
    .p-3.text-center.mb-5
      h5.font-weight-bold.mb-3 我的美容顧問
      .mb-5
        ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
          :profileUrl="saData.picture_url",
          :style="{ 'width': '200px', 'height': '200px' }"
        )
      p.mb-2 {{ saData.chinese_last_name }} {{ saData.chinese_first_name }}
      p.mb-0
        i.fas.fa-map-marker-alt.mr-2
        span 門市：
        b-badge(
          variant="primary",
          v-for="store in saData.stores",
          :key="store.id",
          class="py-2 m-1"
        ) {{ store.store_dealer_title }}/{{ store.title }}
    .row.p-3.pt-5.mx-2
      .col-6
        b-button(
          variant="primary",
          block,
          @click="unbindHandler()"
        ) 解除綁定
      .col-6
        b-button(
          variant="primary",
          block,
          @click="backToLINEHandler()"
        ) 與顧問一對一

</template>

<script>
import { mapState } from 'vuex';
import { M_UNBIND_SUCCESS } from '@/router/member/my-sa';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'MySaIndex',
  components: {
    ProfilePhotoSticker
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('member_my_sa/getSaProfileHandler')
      .then(() => {
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    unbindHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '您確定解除與顧問的綁定?',
        text: '解除後需重新綁定方可使用一對一服務！',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary px-5'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '解除綁定中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          // 解除綁定
          vm.$store.dispatch('member_my_sa/unbindSaHandler')
            .then(() => {
              vm.$swal.close();
              vm.$router.push({
                name: M_UNBIND_SUCCESS
              });
            });
        }
      });
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  },
  computed: {
    ...mapState({
      saData: (state) => state.member_my_sa.saData
    })
  }
};
</script>

<style>

</style>
